module.exports = __webpack_public_path__ + "media/images/covers/discover-your-future/discover-logo-8-95695aa56c9404c6fc04e59221de4107.png";